<template>
  <div>
    <v-tooltip
      v-if="mixValidaScopesActions(2)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar()">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
      v-if="mixValidaScopesActions(3)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar()">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesInfraestructuraConfiguracionCaracteristciasSubtiposInfraestructura',
  props: {
    caracteristicaSubtipoInfraestructura: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-caracteristica-subtipo-infraestructura', this.caracteristicaSubtipoInfraestructura);
    },
    borrar() {
      eventBus.$emit('eliminar-caracteristica-subtipo-infraestructura', this.caracteristicaSubtipoInfraestructura);
    },
  },
};
</script>

<style lang="scss"></style>
